import { render, staticRenderFns } from "./ResumeIVRsChart.vue?vue&type=template&id=08f0d7ad"
import script from "./ResumeIVRsChart.vue?vue&type=script&lang=ts"
export * from "./ResumeIVRsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports